module.exports = __webpack_public_path__ + "static/media/about04.6d81249e.png";